/**
 * Vite Entry Point - v4.js
 *
 * Migrado de Webpack require.context para Vite import.meta.glob
 * Mantém compatibilidade com react_ujs
 */

// CRÍTICO: Importar inicialização do I18n PRIMEIRO
// Isso garante que I18n esteja disponível antes de qualquer outro módulo ser carregado
import '../v4/support/i18n-init';

// Importar CSS do pack (arquivo vazio mínimo para evitar erro 404)
import './v4.css';

// Turbolinks global (usado por muitos componentes para navegação)
import Turbolinks from 'turbolinks';
if (typeof window !== 'undefined') {
  // Disponibilizar Turbolinks globalmente
  window.Turbolinks = Turbolinks;
  // Inicializar Turbolinks apenas uma vez
  if (!window.Turbolinks.controller) {
    Turbolinks.start();
  }
}

// lodash global (também usado por alguns módulos)
import lodash from 'lodash-es';
if (typeof window !== 'undefined') {
  window._ = lodash;
}

// Usar import.meta.glob para carregar todos os componentes dinamicamente
// eager: true garante carregamento síncrono compatível com react_ujs
// NOTA: I18n e lodash já estão disponíveis globalmente antes deste ponto
// Auto-generated component imports (replaces import.meta.glob for esbuild)
import * as Component_0 from '../components/v4/accounts/Edit.js';
import * as Component_1 from '../components/v4/accounts/Form.js';
import * as Component_2 from '../components/v4/accounts/New.js';
import * as Component_3 from '../components/v4/accounts/OrganizationList.js';
import * as Component_4 from '../components/v4/accounts/TabPanel.js';
import * as Component_5 from '../components/v4/admin/dashboard/Index.js';
import * as Component_6 from '../components/v4/admin/dashboard/MainMenu.js';
import * as Component_7 from '../components/v4/admin/dashboard/ReportsMenu.js';
import * as Component_8 from '../components/v4/admin/dashboard/RouterOutlet.js';
import * as Component_9 from '../components/v4/admin/equipment_measures/Audits.js';
import * as Component_10 from '../components/v4/admin/equipment_measures/DeleteMeasureDialog.js';
import * as Component_11 from '../components/v4/admin/equipment_measures/Edit.js';
import * as Component_12 from '../components/v4/admin/equipment_measures/Form.js';
import * as Component_13 from '../components/v4/admin/equipment_measures/Index.js';
import * as Component_14 from '../components/v4/admin/equipment_measures/New.js';
import * as Component_15 from '../components/v4/admin/hardware_products/Edit.js';
import * as Component_16 from '../components/v4/admin/hardware_products/Form.js';
import * as Component_17 from '../components/v4/admin/hardware_products/Index.js';
import * as Component_18 from '../components/v4/admin/hardware_products/New.js';
import * as Component_19 from '../components/v4/admin/hardware_products/Show.js';
import * as Component_20 from '../components/v4/admin/organizations/alerts/Edit.js';
import * as Component_21 from '../components/v4/admin/organizations/alerts/Form.js';
import * as Component_22 from '../components/v4/admin/organizations/alerts/Index.js';
import * as Component_23 from '../components/v4/admin/organizations/alerts/Show.js';
import * as Component_24 from '../components/v4/admin/organizations/assets/AcquisitionTypeDialog.js';
import * as Component_25 from '../components/v4/admin/organizations/assets/Index.js';
import * as Component_26 from '../components/v4/admin/organizations/assets/Timeline.js';
import * as Component_27 from '../components/v4/admin/organizations/contacts/Edit.js';
import * as Component_28 from '../components/v4/admin/organizations/contacts/Form.js';
import * as Component_29 from '../components/v4/admin/organizations/contacts/Index.js';
import * as Component_30 from '../components/v4/admin/organizations/contacts/New.js';
import * as Component_31 from '../components/v4/admin/organizations/Edit.js';
import * as Component_32 from '../components/v4/admin/organizations/Form.js';
import * as Component_33 from '../components/v4/admin/organizations/Index.js';
import * as Component_34 from '../components/v4/admin/organizations/New.js';
import * as Component_35 from '../components/v4/admin/organizations/organization_products/alert/product_configs/AlertSettings.js';
import * as Component_36 from '../components/v4/admin/organizations/organization_products/alert/product_configs/Form.js';
import * as Component_37 from '../components/v4/admin/organizations/organization_products/Edit.js';
import * as Component_38 from '../components/v4/admin/organizations/organization_products/EditForm.js';
import * as Component_39 from '../components/v4/admin/organizations/organization_products/field_notebook/DialogForm.js';
import * as Component_40 from '../components/v4/admin/organizations/organization_products/field_notebook/Edit.js';
import * as Component_41 from '../components/v4/admin/organizations/organization_products/field_notebook/Form.js';
import * as Component_42 from '../components/v4/admin/organizations/organization_products/forecast/points/EditForm.js';
import * as Component_43 from '../components/v4/admin/organizations/organization_products/forecast/points/Index.js';
import * as Component_44 from '../components/v4/admin/organizations/organization_products/forecast/points/Points.js';
import * as Component_45 from '../components/v4/admin/organizations/organization_products/forecast/points/Show.js';
import * as Component_46 from '../components/v4/admin/organizations/organization_products/forecast/points/styles.js';
import * as Component_47 from '../components/v4/admin/organizations/organization_products/forecast/points/TableForm.js';
import * as Component_48 from '../components/v4/admin/organizations/organization_products/Form.js';
import * as Component_49 from '../components/v4/admin/organizations/organization_products/Index.js';
import * as Component_50 from '../components/v4/admin/organizations/organization_products/insight/DialogForm.js';
import * as Component_51 from '../components/v4/admin/organizations/organization_products/insight/Edit.js';
import * as Component_52 from '../components/v4/admin/organizations/organization_products/insight/Form.js';
import * as Component_53 from '../components/v4/admin/organizations/organization_products/irrigation_management/Edit.js';
import * as Component_54 from '../components/v4/admin/organizations/organization_products/irrigation_management/Form.js';
import * as Component_55 from '../components/v4/admin/organizations/organization_products/New.js';
import * as Component_56 from '../components/v4/admin/organizations/organization_products/notifications/weather_forecast/Index.js';
import * as Component_57 from '../components/v4/admin/organizations/organization_products/satellite_imagery/Edit.js';
import * as Component_58 from '../components/v4/admin/organizations/organization_products/satellite_imagery/Form.js';
import * as Component_59 from '../components/v4/admin/organizations/Show.js';
import * as Component_60 from '../components/v4/admin/organizations/subscriptions/Index.js';
import * as Component_61 from '../components/v4/admin/organizations/users/Edit.js';
import * as Component_62 from '../components/v4/admin/organizations/users/EditForm.js';
import * as Component_63 from '../components/v4/admin/organizations/users/Index.js';
import * as Component_64 from '../components/v4/admin/organizations/users/NewForm.js';
import * as Component_65 from '../components/v4/admin/organizations/users/NewInvitation.js';
import * as Component_66 from '../components/v4/admin/organizations/users/Show.js';
import * as Component_67 from '../components/v4/admin/part_number_registries/Edit.js';
import * as Component_68 from '../components/v4/admin/part_number_registries/Form.js';
import * as Component_69 from '../components/v4/admin/part_number_registries/Index.js';
import * as Component_70 from '../components/v4/admin/part_number_registries/New.js';
import * as Component_71 from '../components/v4/admin/part_number_registries/Show.js';
import * as Component_72 from '../components/v4/admin/part_number_registries/styles.js';
import * as Component_73 from '../components/v4/admin/part_number_registries/stylesShow.js';
import * as Component_74 from '../components/v4/admin/privacy_policies/Edit.js';
import * as Component_75 from '../components/v4/admin/privacy_policies/Form.js';
import * as Component_76 from '../components/v4/admin/privacy_policies/Index.js';
import * as Component_77 from '../components/v4/admin/privacy_policies/New.js';
import * as Component_78 from '../components/v4/admin/products/Edit.js';
import * as Component_79 from '../components/v4/admin/products/Form.js';
import * as Component_80 from '../components/v4/admin/products/Index.js';
import * as Component_81 from '../components/v4/admin/products/New.js';
import * as Component_82 from '../components/v4/admin/products/ParamsTable.js';
import * as Component_83 from '../components/v4/admin/products/Show.js';
import * as Component_84 from '../components/v4/admin/reports/ClimateReport.js';
import * as Component_85 from '../components/v4/admin/reports/IrrigationReport.js';
import * as Component_86 from '../components/v4/admin/reports/SatelliteImageReport.js';
import * as Component_87 from '../components/v4/admin/sensor_configs/Edit.js';
import * as Component_88 from '../components/v4/admin/sensor_configs/Form.js';
import * as Component_89 from '../components/v4/admin/sensor_configs/Index.js';
import * as Component_90 from '../components/v4/admin/sensor_configs/New.js';
import * as Component_91 from '../components/v4/admin/sensor_configs/Show.js';
import * as Component_92 from '../components/v4/admin/sensor_configs/style.js';
import * as Component_93 from '../components/v4/admin/sensors/Edit.js';
import * as Component_94 from '../components/v4/admin/sensors/Form.js';
import * as Component_95 from '../components/v4/admin/sensors/Index.js';
import * as Component_96 from '../components/v4/admin/sensors/New.js';
import * as Component_97 from '../components/v4/admin/sensors/ParamsTable.js';
import * as Component_98 from '../components/v4/admin/sensors/Show.js';
import * as Component_99 from '../components/v4/admin/tenants/ColorsForm/BackgroundColorForm.js';
import * as Component_100 from '../components/v4/admin/tenants/ColorsForm/BarsColorsForm.js';
import * as Component_101 from '../components/v4/admin/tenants/ColorsForm/DefaultColorsForm.js';
import * as Component_102 from '../components/v4/admin/tenants/ColorsForm/Index.js';
import * as Component_103 from '../components/v4/admin/tenants/ColorsForm/MainColorsForm.js';
import * as Component_104 from '../components/v4/admin/tenants/ColorsForm/PaperBackgroundColorForm.js';
import * as Component_105 from '../components/v4/admin/tenants/ColorsForm/PrimaryTextForm.js';
import * as Component_106 from '../components/v4/admin/tenants/ColorsForm/SecondaryTextForm.js';
import * as Component_107 from '../components/v4/admin/tenants/ColorsForm/style.js';
import * as Component_108 from '../components/v4/admin/tenants/Edit.js';
import * as Component_109 from '../components/v4/admin/tenants/EmailConfigurationForm/index.js';
import * as Component_110 from '../components/v4/admin/tenants/Form.js';
import * as Component_111 from '../components/v4/admin/tenants/Index.js';
import * as Component_112 from '../components/v4/admin/tenants/LoginScreenForm/Index.js';
import * as Component_113 from '../components/v4/admin/tenants/LoginScreenForm/LoginScreenPreview.js';
import * as Component_114 from '../components/v4/admin/tenants/New.js';
import * as Component_115 from '../components/v4/admin/tenants/Steppers/index.js';
import * as Component_116 from '../components/v4/admin/tenants/Steppers/style.js';
import * as Component_117 from '../components/v4/admin/tenants/TenantPreview/FormPreview.js';
import * as Component_118 from '../components/v4/admin/tenants/TenantPreview/index.js';
import * as Component_119 from '../components/v4/admin/tenants/TenantPreview/NavBarPreview.js';
import * as Component_120 from '../components/v4/admin/tenants/TenantPreview/PreviewScreen.js';
import * as Component_121 from '../components/v4/admin/tenants/TenantPreview/previewStyles.js';
import * as Component_122 from '../components/v4/admin/tenants/TenantPreview/SideBarPreview.js';
import * as Component_123 from '../components/v4/admin/tenants/terms/Edit.js';
import * as Component_124 from '../components/v4/admin/tenants/terms/Form.js';
import * as Component_125 from '../components/v4/admin/tenants/terms/Index.js';
import * as Component_126 from '../components/v4/admin/tenants/terms/New.js';
import * as Component_127 from '../components/v4/admin/tenants/users/Edit.js';
import * as Component_128 from '../components/v4/admin/tenants/users/Form.js';
import * as Component_129 from '../components/v4/admin/tenants/users/Index.js';
import * as Component_130 from '../components/v4/admin/tenants/users/New.js';
import * as Component_131 from '../components/v4/admin/tenants/users/Show.js';
import * as Component_132 from '../components/v4/alerts/Edit.js';
import * as Component_133 from '../components/v4/alerts/Filter.js';
import * as Component_134 from '../components/v4/alerts/Index.js';
import * as Component_135 from '../components/v4/alerts/new_alert/AlertNameStep.js';
import * as Component_136 from '../components/v4/alerts/new_alert/AlertPreviewStep.js';
import * as Component_137 from '../components/v4/alerts/new_alert/CreateAreaStep.js';
import * as Component_138 from '../components/v4/alerts/new_alert/LandingStep.js';
import * as Component_139 from '../components/v4/alerts/new_alert/MediaForm.js';
import * as Component_140 from '../components/v4/alerts/new_alert/ReceiveAlert.js';
import * as Component_141 from '../components/v4/alerts/new_alert/ReceiveAlertStep.js';
import * as Component_142 from '../components/v4/alerts/new_alert/SelectAreaStep.js';
import * as Component_143 from '../components/v4/alerts/new_alert/SelectEquipmentStep.js';
import * as Component_144 from '../components/v4/alerts/new_alert/SelectVariablesStep.js';
import * as Component_145 from '../components/v4/alerts/new_alert/SetValuesForVariablesStep.js';
import * as Component_146 from '../components/v4/alerts/new_alert/Step.js';
import * as Component_147 from '../components/v4/alerts/New.js';
import * as Component_148 from '../components/v4/alerts/Stepper.js';
import * as Component_149 from '../components/v4/alerts/styles.js';
import * as Component_150 from '../components/v4/App.js';
import * as Component_151 from '../components/v4/areas/analyses/AnalysesList.js';
import * as Component_152 from '../components/v4/areas/analyses/ApiWrapper.js';
import * as Component_153 from '../components/v4/areas/analyses/Form.js';
import * as Component_154 from '../components/v4/areas/analyses/Index.js';
import * as Component_155 from '../components/v4/areas/analyses/samples/Form.js';
import * as Component_156 from '../components/v4/areas/analyses/samples/Index.js';
import * as Component_157 from '../components/v4/areas/analyses/samples/Show.js';
import * as Component_158 from '../components/v4/areas/analyses/samples/styles.js';
import * as Component_159 from '../components/v4/areas/analyses/styles.js';
import * as Component_160 from '../components/v4/areas/Dashboard.js';
import * as Component_161 from '../components/v4/areas/dashboard/Index.js';
import * as Component_162 from '../components/v4/areas/dashboard/InformProdutivity.js';
import * as Component_163 from '../components/v4/areas/dashboard/LastPlantationsTable.js';
import * as Component_164 from '../components/v4/areas/dashboard/NewPlantation.js';
import * as Component_165 from '../components/v4/areas/dashboard/NewPlantationForm.js';
import * as Component_166 from '../components/v4/areas/dashboard/NewPlantationFormWrapper.js';
import * as Component_167 from '../components/v4/areas/dashboard/ShowProdutivity.js';
import * as Component_168 from '../components/v4/areas/dashboard/styles.js';
import * as Component_169 from '../components/v4/areas/Edit.js';
import * as Component_170 from '../components/v4/areas/Form.js';
import * as Component_171 from '../components/v4/areas/Index.js';
import * as Component_172 from '../components/v4/areas/notes/AreaFields.js';
import * as Component_173 from '../components/v4/areas/notes/Dialog.js';
import * as Component_174 from '../components/v4/areas/notes/Form.js';
import * as Component_175 from '../components/v4/areas/notes/FormWrapper.js';
import * as Component_176 from '../components/v4/attachments/Index.js';
import * as Component_177 from '../components/v4/checkout/BillingData.js';
import * as Component_178 from '../components/v4/checkout/BillingDataForm.js';
import * as Component_179 from '../components/v4/checkout/BillingInfo.js';
import * as Component_180 from '../components/v4/checkout/CheckoutResume.js';
import * as Component_181 from '../components/v4/checkout/CouponForm.js';
import * as Component_182 from '../components/v4/checkout/CreditCard.js';
import * as Component_183 from '../components/v4/checkout/Index.js';
import * as Component_184 from '../components/v4/checkout/PersonalDataForm.js';
import * as Component_185 from '../components/v4/checkout/styles.js';
import * as Component_186 from '../components/v4/checkout/SuccessScreen.js';
import * as Component_187 from '../components/v4/comparison/Filter.js';
import * as Component_188 from '../components/v4/comparison/Index.js';
import * as Component_189 from '../components/v4/comparison/Map.js';
import * as Component_190 from '../components/v4/comparison/Maps.js';
import * as Component_191 from '../components/v4/cultures/CultureForm.js';
import * as Component_192 from '../components/v4/cultures/Edit.js';
import * as Component_193 from '../components/v4/cultures/Form.js';
import * as Component_194 from '../components/v4/cultures/Index.js';
import * as Component_195 from '../components/v4/cultures/New.js';
import * as Component_196 from '../components/v4/cultures/Show.js';
import * as Component_197 from '../components/v4/cultures/stages/Form.js';
import * as Component_198 from '../components/v4/cultures/stages/Index.js';
import * as Component_199 from '../components/v4/cultures/stages/Show.js';
import * as Component_200 from '../components/v4/cultures/stages/styles.js';
import * as Component_201 from '../components/v4/equipments/Automatic/Edit.js';
import * as Component_202 from '../components/v4/equipments/Automatic/Form.js';
import * as Component_203 from '../components/v4/equipments/Automatic/New.js';
import * as Component_204 from '../components/v4/equipments/Automatic/sensorConfiguration/Form.js';
import * as Component_205 from '../components/v4/equipments/Automatic/sensorConfiguration/Index.js';
import * as Component_206 from '../components/v4/equipments/Automatic/sensorConfiguration/Show.js';
import * as Component_207 from '../components/v4/equipments/Automatic/sensorConfiguration/styles.js';
import * as Component_208 from '../components/v4/equipments/Dashboard.js';
import * as Component_209 from '../components/v4/equipments/dashboard/DashboardCharts.js';
import * as Component_210 from '../components/v4/equipments/dashboard/DashboardTable.js';
import * as Component_211 from '../components/v4/equipments/dashboard/Filter.js';
import * as Component_212 from '../components/v4/equipments/dashboard/Index.js';
import * as Component_213 from '../components/v4/equipments/dashboard/ModalCharts.js';
import * as Component_214 from '../components/v4/equipments/dashboard/styles.js';
import * as Component_215 from '../components/v4/equipments/Edit.js';
import * as Component_216 from '../components/v4/equipments/Form.js';
import * as Component_217 from '../components/v4/equipments/Implements/Edit.js';
import * as Component_218 from '../components/v4/equipments/Implements/Form.js';
import * as Component_219 from '../components/v4/equipments/Implements/New.js';
import * as Component_220 from '../components/v4/equipments/Index.js';
import * as Component_221 from '../components/v4/equipments/irrigations/AreaFields.js';
import * as Component_222 from '../components/v4/equipments/irrigations/BoundedGraphic.js';
import * as Component_223 from '../components/v4/equipments/irrigations/Dialog.js';
import * as Component_224 from '../components/v4/equipments/irrigations/Edit.js';
import * as Component_225 from '../components/v4/equipments/irrigations/EditForm.js';
import * as Component_226 from '../components/v4/equipments/irrigations/Form.js';
import * as Component_227 from '../components/v4/equipments/irrigations/FormWrapper.js';
import * as Component_228 from '../components/v4/equipments/irrigations/Index.js';
import * as Component_229 from '../components/v4/equipments/irrigations/InformIrrigation.js';
import * as Component_230 from '../components/v4/equipments/irrigations/New.js';
import * as Component_231 from '../components/v4/equipments/irrigations/PivotGraphic.js';
import * as Component_232 from '../components/v4/equipments/IrrigationSystem/BoundedForm.js';
import * as Component_233 from '../components/v4/equipments/IrrigationSystem/CalculationResultInfo.js';
import * as Component_234 from '../components/v4/equipments/IrrigationSystem/Edit.js';
import * as Component_235 from '../components/v4/equipments/IrrigationSystem/Form.js';
import * as Component_236 from '../components/v4/equipments/IrrigationSystem/New.js';
import * as Component_237 from '../components/v4/equipments/IrrigationSystem/PivotForm.js';
import * as Component_238 from '../components/v4/equipments/Manual/Edit.js';
import * as Component_239 from '../components/v4/equipments/Manual/Form.js';
import * as Component_240 from '../components/v4/equipments/Manual/New.js';
import * as Component_241 from '../components/v4/equipments/measures/DashboardTable.js';
import * as Component_242 from '../components/v4/equipments/measures/FilterForm.js';
import * as Component_243 from '../components/v4/equipments/measures/Header.js';
import * as Component_244 from '../components/v4/equipments/measures/Index.js';
import * as Component_245 from '../components/v4/equipments/measures/ModalForm.js';
import * as Component_246 from '../components/v4/equipments/New.js';
import * as Component_247 from '../components/v4/equipments/Show.js';
import * as Component_248 from '../components/v4/equipments/Tractor/Edit.js';
import * as Component_249 from '../components/v4/equipments/Tractor/Form.js';
import * as Component_250 from '../components/v4/equipments/Tractor/New.js';
import * as Component_251 from '../components/v4/errors/Index.js';
import * as Component_252 from '../components/v4/errors/styles.js';
import * as Component_253 from '../components/v4/field_notebooks/Card.js';
import * as Component_254 from '../components/v4/field_notebooks/CardContent.js';
import * as Component_255 from '../components/v4/field_notebooks/CardRedirectToMobile.js';
import * as Component_256 from '../components/v4/field_notebooks/Header.js';
import * as Component_257 from '../components/v4/field_notebooks/Index.js';
import * as Component_258 from '../components/v4/forecast-cards/card.js';
import * as Component_259 from '../components/v4/forecast-cards/forecast-point-form.js';
import * as Component_260 from '../components/v4/forecast-cards/forecast-resume.js';
import * as Component_261 from '../components/v4/forecast-cards/forecast.js';
import * as Component_262 from '../components/v4/forecast-cards/Index.js';
import * as Component_263 from '../components/v4/forecast-cards/styles.js';
import * as Component_264 from '../components/v4/index.js';
import * as Component_265 from '../components/v4/inputs/chemicals/Edit.js';
import * as Component_266 from '../components/v4/inputs/chemicals/Form.js';
import * as Component_267 from '../components/v4/inputs/chemicals/New.js';
import * as Component_268 from '../components/v4/inputs/cultivar/Edit.js';
import * as Component_269 from '../components/v4/inputs/cultivar/Form.js';
import * as Component_270 from '../components/v4/inputs/cultivar/New.js';
import * as Component_271 from '../components/v4/inputs/Edit.js';
import * as Component_272 from '../components/v4/inputs/fertilizers/Edit.js';
import * as Component_273 from '../components/v4/inputs/fertilizers/Form.js';
import * as Component_274 from '../components/v4/inputs/fertilizers/New.js';
import * as Component_275 from '../components/v4/inputs/Form.js';
import * as Component_276 from '../components/v4/inputs/Index.js';
import * as Component_277 from '../components/v4/inputs/New.js';
import * as Component_278 from '../components/v4/inputs/others/Edit.js';
import * as Component_279 from '../components/v4/inputs/others/Form.js';
import * as Component_280 from '../components/v4/inputs/others/New.js';
import * as Component_281 from '../components/v4/inputs/Show.js';
import * as Component_282 from '../components/v4/insights/Index.js';
import * as Component_283 from '../components/v4/irrigation_managements/ButtonArea.js';
import * as Component_284 from '../components/v4/irrigation_managements/Dashboard.js';
import * as Component_285 from '../components/v4/irrigation_managements/Edit.js';
import * as Component_286 from '../components/v4/irrigation_managements/Form.js';
import * as Component_287 from '../components/v4/irrigation_managements/form/AdvancedParams/AvailableWater.js';
import * as Component_288 from '../components/v4/irrigation_managements/form/AdvancedParams/CorrectionFactor.js';
import * as Component_289 from '../components/v4/irrigation_managements/form/AdvancedParams/index.js';
import * as Component_290 from '../components/v4/irrigation_managements/form/AdvancedParams/Panel.js';
import * as Component_291 from '../components/v4/irrigation_managements/form/AdvancedParams/RootDepth.js';
import * as Component_292 from '../components/v4/irrigation_managements/form/AdvancedParams/Table.js';
import * as Component_293 from '../components/v4/irrigation_managements/form/AdvancedParamsDialog.js';
import * as Component_294 from '../components/v4/irrigation_managements/form/AreaFields.js';
import * as Component_295 from '../components/v4/irrigation_managements/form/CustomField.js';
import * as Component_296 from '../components/v4/irrigation_managements/form/ForecastPoint/Form.js';
import * as Component_297 from '../components/v4/irrigation_managements/form/ForecastPoint/index.js';
import * as Component_298 from '../components/v4/irrigation_managements/Index.js';
import * as Component_299 from '../components/v4/irrigation_managements/inform.js';
import * as Component_300 from '../components/v4/irrigation_managements/New.js';
import * as Component_301 from '../components/v4/irrigation_managements/styles.js';
import * as Component_302 from '../components/v4/irrigation/management/chartLegend/index.js';
import * as Component_303 from '../components/v4/irrigation/management/chartLegend/styles.js';
import * as Component_304 from '../components/v4/irrigation/management/chartTooltip/index.js';
import * as Component_305 from '../components/v4/irrigation/management/chartTooltip/styles.js';
import * as Component_306 from '../components/v4/irrigation/management/dataSummaryCard/index.js';
import * as Component_307 from '../components/v4/irrigation/management/dataSummaryCard/styles.js';
import * as Component_308 from '../components/v4/irrigation/management/eventsMap/customizedDotHandler/index.js';
import * as Component_309 from '../components/v4/irrigation/management/eventsMap/eventsMapLegend/index.js';
import * as Component_310 from '../components/v4/irrigation/management/eventsMap/eventsMapTooltip/index.js';
import * as Component_311 from '../components/v4/irrigation/management/eventsMap/index.js';
import * as Component_312 from '../components/v4/irrigation/management/hydricStatus/index.js';
import * as Component_313 from '../components/v4/irrigation/management/index.js';
import * as Component_314 from '../components/v4/irrigation/management/irrigationChart/ChartsGenerator/ChartsGenerator.js';
import * as Component_315 from '../components/v4/irrigation/management/irrigationChart/index.js';
import * as Component_316 from '../components/v4/irrigation/management/irrigationChart/irrigationChartLegend/index.js';
import * as Component_317 from '../components/v4/irrigation/management/irrigationChart/PhenologicalStageReferenceLabel.js';
import * as Component_318 from '../components/v4/irrigation/management/irrigationChart/styles.js';
import * as Component_319 from '../components/v4/irrigation/management/irrigationManagementContent/index.js';
import * as Component_320 from '../components/v4/irrigation/management/irrigationManagementNavBar/index.js';
import * as Component_321 from '../components/v4/irrigation/management/irrigationManagementNavBar/managementDescription.js';
import * as Component_322 from '../components/v4/irrigation/management/irrigationManagementNavBar/managementDisplayOption.js';
import * as Component_323 from '../components/v4/login/AppleIcon.js';
import * as Component_324 from '../components/v4/login/ConfirmEmailDialog/ContentBody.js';
import * as Component_325 from '../components/v4/login/ConfirmEmailDialog/ContentControl.js';
import * as Component_326 from '../components/v4/login/ConfirmEmailDialog/Index.js';
import * as Component_327 from '../components/v4/login/ConfirmEmailDialog/styles.js';
import * as Component_328 from '../components/v4/login/ConfirmInviteScreen.js';
import * as Component_329 from '../components/v4/login/DeviseScreen.js';
import * as Component_330 from '../components/v4/login/EditPassword.js';
import * as Component_331 from '../components/v4/login/Login.js';
import * as Component_332 from '../components/v4/login/MicrosoftIcon.js';
import * as Component_333 from '../components/v4/login/RetrievePassword.js';
import * as Component_334 from '../components/v4/login/SelectLocale.js';
import * as Component_335 from '../components/v4/login/SignUp.js';
import * as Component_336 from '../components/v4/login/styles.js';
import * as Component_337 from '../components/v4/maps/Controls/Control.js';
import * as Component_338 from '../components/v4/maps/Controls/index.js';
import * as Component_339 from '../components/v4/maps/Index.js';
import * as Component_340 from '../components/v4/maps/infoMenu/Alerts/index.js';
import * as Component_341 from '../components/v4/maps/infoMenu/Area/Action.js';
import * as Component_342 from '../components/v4/maps/infoMenu/Area/CancelHarvest.js';
import * as Component_343 from '../components/v4/maps/infoMenu/Area/CropContent.js';
import * as Component_344 from '../components/v4/maps/infoMenu/Area/EditArea.js';
import * as Component_345 from '../components/v4/maps/infoMenu/Area/ExpiredPhase.js';
import * as Component_346 from '../components/v4/maps/infoMenu/Area/FormCrop.js';
import * as Component_347 from '../components/v4/maps/infoMenu/Area/index.js';
import * as Component_348 from '../components/v4/maps/infoMenu/Area/Intercom.js';
import * as Component_349 from '../components/v4/maps/infoMenu/Area/ProductsContent.js';
import * as Component_350 from '../components/v4/maps/infoMenu/Area/ViewProduct.js';
import * as Component_351 from '../components/v4/maps/infoMenu/AreaInfo.js';
import * as Component_352 from '../components/v4/maps/infoMenu/Equipment/Action.js';
import * as Component_353 from '../components/v4/maps/infoMenu/Equipment/Battery.js';
import * as Component_354 from '../components/v4/maps/infoMenu/Equipment/DepthTable.js';
import * as Component_355 from '../components/v4/maps/infoMenu/Equipment/EquipmentSelect.js';
import * as Component_356 from '../components/v4/maps/infoMenu/Equipment/index.js';
import * as Component_357 from '../components/v4/maps/infoMenu/Equipment/InfoDate.js';
import * as Component_358 from '../components/v4/maps/infoMenu/Equipment/Installed.js';
import * as Component_359 from '../components/v4/maps/infoMenu/Equipment/Offline.js';
import * as Component_360 from '../components/v4/maps/infoMenu/Equipment/Support.js';
import * as Component_361 from '../components/v4/maps/infoMenu/Equipment/Uninstalled.js';
import * as Component_362 from '../components/v4/maps/infoMenu/Equipment/Unknown.js';
import * as Component_363 from '../components/v4/maps/infoMenu/Equipment/Variables.js';
import * as Component_364 from '../components/v4/maps/infoMenu/Hydrometer/Action.js';
import * as Component_365 from '../components/v4/maps/infoMenu/Hydrometer/Body.js';
import * as Component_366 from '../components/v4/maps/infoMenu/Hydrometer/CustomOdometer/index.js';
import * as Component_367 from '../components/v4/maps/infoMenu/Hydrometer/CustomOdometer/OdometerDigit.js';
import * as Component_368 from '../components/v4/maps/infoMenu/Hydrometer/Form.js';
import * as Component_369 from '../components/v4/maps/infoMenu/Hydrometer/Header.js';
import * as Component_370 from '../components/v4/maps/infoMenu/Hydrometer/HoursTabs.js';
import * as Component_371 from '../components/v4/maps/infoMenu/Hydrometer/index.js';
import * as Component_372 from '../components/v4/maps/infoMenu/Hydrometer/WrapperOdometer.js';
import * as Component_373 from '../components/v4/maps/infoMenu/Index.js';
import * as Component_374 from '../components/v4/maps/infoMenu/InfoMenu.js';
import * as Component_375 from '../components/v4/maps/infoMenu/InfoMenuWrapper.js';
import * as Component_376 from '../components/v4/maps/infoMenu/ManualEquipment/Form.js';
import * as Component_377 from '../components/v4/maps/infoMenu/ManualEquipment/index.js';
import * as Component_378 from '../components/v4/maps/infoMenu/ManualEquipment/InfoRain.js';
import * as Component_379 from '../components/v4/maps/infoMenu/ManualEquipment/RainHistory.js';
import * as Component_380 from '../components/v4/maps/infoMenu/styles.js';
import * as Component_381 from '../components/v4/maps/IrrigationManagement/Cards/Card.js';
import * as Component_382 from '../components/v4/maps/IrrigationManagement/Cards/CurrentIrrigationCard.js';
import * as Component_383 from '../components/v4/maps/IrrigationManagement/Cards/IrrigationForecastCard.js';
import * as Component_384 from '../components/v4/maps/IrrigationManagement/Cards/LegendCard.js';
import * as Component_385 from '../components/v4/maps/IrrigationManagement/Cards/ResumeCard.js';
import * as Component_386 from '../components/v4/maps/IrrigationManagement/index.js';
import * as Component_387 from '../components/v4/maps/Map.js';
import * as Component_388 from '../components/v4/maps/MapColorsLegend.js';
import * as Component_389 from '../components/v4/maps/NewAreaDialog.js';
import * as Component_390 from '../components/v4/maps/NewAreaFileForm.js';
import * as Component_391 from '../components/v4/maps/NewAreaForm.js';
import * as Component_392 from '../components/v4/maps/NewAreasTable.js';
import * as Component_393 from '../components/v4/maps/products/Index.js';
import * as Component_394 from '../components/v4/maps/products/styles.js';
import * as Component_395 from '../components/v4/maps/productsFloatingMenu/Atmos/ApplicationCondition/Application.js';
import * as Component_396 from '../components/v4/maps/productsFloatingMenu/Atmos/ApplicationCondition/ConditionDays.js';
import * as Component_397 from '../components/v4/maps/productsFloatingMenu/Atmos/ApplicationCondition/index.js';
import * as Component_398 from '../components/v4/maps/productsFloatingMenu/Atmos/Body.js';
import * as Component_399 from '../components/v4/maps/productsFloatingMenu/Atmos/Card.js';
import * as Component_400 from '../components/v4/maps/productsFloatingMenu/Atmos/EmptyData.js';
import * as Component_401 from '../components/v4/maps/productsFloatingMenu/Atmos/Footer.js';
import * as Component_402 from '../components/v4/maps/productsFloatingMenu/Atmos/Header.js';
import * as Component_403 from '../components/v4/maps/productsFloatingMenu/Atmos/Index.js';
import * as Component_404 from '../components/v4/maps/productsFloatingMenu/Atmos/SetupNewForecastPoint/Dialog.js';
import * as Component_405 from '../components/v4/maps/productsFloatingMenu/Atmos/SetupNewForecastPoint/FpNameForm.js';
import * as Component_406 from '../components/v4/maps/productsFloatingMenu/Atmos/SetupNewForecastPoint/Index.js';
import * as Component_407 from '../components/v4/maps/productsFloatingMenu/Atmos/SetupNewForecastPoint/LatLongForm.js';
import * as Component_408 from '../components/v4/maps/productsFloatingMenu/Atmos/SetupNewForecastPoint/Selector.js';
import * as Component_409 from '../components/v4/maps/productsFloatingMenu/Atmos/Wrapper.js';
import * as Component_410 from '../components/v4/maps/productsFloatingMenu/EditAreaMenu/Action.js';
import * as Component_411 from '../components/v4/maps/productsFloatingMenu/EditAreaMenu/index.js';
import * as Component_412 from '../components/v4/maps/productsFloatingMenu/ExpiredProductCard.js';
import * as Component_413 from '../components/v4/maps/productsFloatingMenu/Index.js';
import * as Component_414 from '../components/v4/maps/productsFloatingMenu/IrrigationManagement/Cards/Card.js';
import * as Component_415 from '../components/v4/maps/productsFloatingMenu/IrrigationManagement/Cards/IrrigationForecastCard.js';
import * as Component_416 from '../components/v4/maps/productsFloatingMenu/IrrigationManagement/Cards/LegendCard.js';
import * as Component_417 from '../components/v4/maps/productsFloatingMenu/IrrigationManagement/Cards/ResumeCard.js';
import * as Component_418 from '../components/v4/maps/productsFloatingMenu/IrrigationManagement/Header.js';
import * as Component_419 from '../components/v4/maps/productsFloatingMenu/IrrigationManagement/index.js';
import * as Component_420 from '../components/v4/maps/productsFloatingMenu/ProductsWrapper.js';
import * as Component_421 from '../components/v4/maps/productsFloatingMenu/View/CardCreateArea.js';
import * as Component_422 from '../components/v4/maps/productsFloatingMenu/View/ColorsLegend.js';
import * as Component_423 from '../components/v4/maps/productsFloatingMenu/View/FilterForm.js';
import * as Component_424 from '../components/v4/maps/productsFloatingMenu/View/FooterMenu.js';
import * as Component_425 from '../components/v4/maps/productsFloatingMenu/View/Index.js';
import * as Component_426 from '../components/v4/maps/productsFloatingMenu/View/SampleCard.js';
import * as Component_427 from '../components/v4/maps/productsFloatingMenu/View/Tabs.js';
import * as Component_428 from '../components/v4/maps/SatelliteImages/FilterForm.js';
import * as Component_429 from '../components/v4/maps/SatelliteImages/Index.js';
import * as Component_430 from '../components/v4/maps/SatelliteImages/SampleCard.js';
import * as Component_431 from '../components/v4/maps/SatelliteImages/styles.js';
import * as Component_432 from '../components/v4/maps/search/Index.js';
import * as Component_433 from '../components/v4/maps/styles.js';
import * as Component_434 from '../components/v4/notification_center/Index.js';
import * as Component_435 from '../components/v4/notification_center/styles.js';
import * as Component_436 from '../components/v4/notifications/Form.js';
import * as Component_437 from '../components/v4/notifications/Index.js';
import * as Component_438 from '../components/v4/notifications/styles.js';
import * as Component_439 from '../components/v4/organizations/billing_info/Edit.js';
import * as Component_440 from '../components/v4/organizations/billing_info/Form.js';
import * as Component_441 from '../components/v4/organizations/Edit.js';
import * as Component_442 from '../components/v4/organizations/Form.js';
import * as Component_443 from '../components/v4/organizations/Index.js';
import * as Component_444 from '../components/v4/organizations/invoices/Index.js';
import * as Component_445 from '../components/v4/organizations/invoices/styles.js';
import * as Component_446 from '../components/v4/organizations/New.js';
import * as Component_447 from '../components/v4/organizations/payment_profiles/Form.js';
import * as Component_448 from '../components/v4/organizations/payment_profiles/Index.js';
import * as Component_449 from '../components/v4/organizations/payment_profiles/New.js';
import * as Component_450 from '../components/v4/organizations/PaymentInfoTabs.js';
import * as Component_451 from '../components/v4/organizations/Show.js';
import * as Component_452 from '../components/v4/organizations/subscriptions/Edit.js';
import * as Component_453 from '../components/v4/organizations/subscriptions/Form.js';
import * as Component_454 from '../components/v4/organizations/subscriptions/Index.js';
import * as Component_455 from '../components/v4/organizations/users/Form.js';
import * as Component_456 from '../components/v4/organizations/users/Index.js';
import * as Component_457 from '../components/v4/organizations/users/NewInvitation.js';
import * as Component_458 from '../components/v4/organizations/users/Show.js';
import * as Component_459 from '../components/v4/seasons/Dashboard/index.js';
import * as Component_460 from '../components/v4/seasons/Edit.js';
import * as Component_461 from '../components/v4/seasons/Form.js';
import * as Component_462 from '../components/v4/seasons/Index.js';
import * as Component_463 from '../components/v4/seasons/New.js';
import * as Component_464 from '../components/v4/seasons/Show.js';
import * as Component_465 from '../components/v4/seasons/styles.js';
import * as Component_466 from '../components/v4/store/admin/coupons/Edit.js';
import * as Component_467 from '../components/v4/store/admin/coupons/Form.js';
import * as Component_468 from '../components/v4/store/admin/coupons/Index.js';
import * as Component_469 from '../components/v4/store/admin/coupons/New.js';
import * as Component_470 from '../components/v4/store/admin/coupons/plans_products/Form.js';
import * as Component_471 from '../components/v4/store/admin/coupons/plans_products/Index.js';
import * as Component_472 from '../components/v4/store/admin/plans/Edit.js';
import * as Component_473 from '../components/v4/store/admin/plans/Form.js';
import * as Component_474 from '../components/v4/store/admin/plans/Index.js';
import * as Component_475 from '../components/v4/store/admin/plans/New.js';
import * as Component_476 from '../components/v4/store/catalogs/Card.js';
import * as Component_477 from '../components/v4/store/catalogs/Checkout.js';
import * as Component_478 from '../components/v4/store/catalogs/Index.js';
import * as Component_479 from '../components/v4/store/catalogs/Navbar.js';
import * as Component_480 from '../components/v4/store/catalogs/Show.js';
import * as Component_481 from '../components/v4/store/catalogs/Store.js';
import * as Component_482 from '../components/v4/store/catalogs/styles.js';
import * as Component_483 from '../components/v4/ui/ActionDialog/index.js';
import * as Component_484 from '../components/v4/ui/AreaChangeHandler/index.js';
import * as Component_485 from '../components/v4/ui/Banner/index.js';
import * as Component_486 from '../components/v4/ui/Button/index.js';
import * as Component_487 from '../components/v4/ui/ButtonGroup/index.js';
import * as Component_488 from '../components/v4/ui/ButtonGroup/styles.js';
import * as Component_489 from '../components/v4/ui/Charts/index.js';
import * as Component_490 from '../components/v4/ui/Charts/styles.js';
import * as Component_491 from '../components/v4/ui/Charts/tooltip.js';
import * as Component_492 from '../components/v4/ui/ConfirmDialog/Dialog.js';
import * as Component_493 from '../components/v4/ui/ConfirmDialog/index.js';
import * as Component_494 from '../components/v4/ui/CustomRadioButton/index.js';
import * as Component_495 from '../components/v4/ui/CustomRadioButton/styles.js';
import * as Component_496 from '../components/v4/ui/DeleteDialog/index.js';
import * as Component_497 from '../components/v4/ui/Dialog/index.js';
import * as Component_498 from '../components/v4/ui/ExpiredTrial/index.js';
import * as Component_499 from '../components/v4/ui/Fields/CheckBox/index.js';
import * as Component_500 from '../components/v4/ui/Fields/ColorPicker/index.js';
import * as Component_501 from '../components/v4/ui/Fields/ColorPicker/styles.js';
import * as Component_502 from '../components/v4/ui/Fields/ControlledFormField/index.js';
import * as Component_503 from '../components/v4/ui/Fields/ControlledSelect/index.js';
import * as Component_504 from '../components/v4/ui/Fields/DatePicker/index.js';
import * as Component_505 from '../components/v4/ui/Fields/DateTimePicker/index.js';
import * as Component_506 from '../components/v4/ui/Fields/DirectUploadDropzone/FilesTable.js';
import * as Component_507 from '../components/v4/ui/Fields/DirectUploadDropzone/index.js';
import * as Component_508 from '../components/v4/ui/Fields/Dropzone/index.js';
import * as Component_509 from '../components/v4/ui/Fields/Field/Fields.js';
import * as Component_510 from '../components/v4/ui/Fields/Field/index.js';
import * as Component_511 from '../components/v4/ui/Fields/FlagIcon/Index.js';
import * as Component_512 from '../components/v4/ui/Fields/FlagIcon/styles.js';
import * as Component_513 from '../components/v4/ui/Fields/MultipleSelect/index.js';
import * as Component_514 from '../components/v4/ui/Fields/MultipleSelect/styles.js';
import * as Component_515 from '../components/v4/ui/Fields/PillTextField/index.js';
import * as Component_516 from '../components/v4/ui/Fields/PillTextField/styles.js';
import * as Component_517 from '../components/v4/ui/Fields/SearchSelect/index.js';
import * as Component_518 from '../components/v4/ui/Fields/SearchSelect/styles.js';
import * as Component_519 from '../components/v4/ui/Fields/Select/index.js';
import * as Component_520 from '../components/v4/ui/Fields/SelectWithVisitButton/index.js';
import * as Component_521 from '../components/v4/ui/Fields/SwitchField/index.js';
import * as Component_522 from '../components/v4/ui/Fields/Telephone/index.js';
import * as Component_523 from '../components/v4/ui/Fields/TextField/index.js';
import * as Component_524 from '../components/v4/ui/Fields/TextFieldWithMask/index.js';
import * as Component_525 from '../components/v4/ui/Fields/TimePicker/index.js';
import * as Component_526 from '../components/v4/ui/Form/index.js';
import * as Component_527 from '../components/v4/ui/Icons/bank_slip.js';
import * as Component_528 from '../components/v4/ui/Icons/Check.js';
import * as Component_529 from '../components/v4/ui/Icons/ConfirmEmail.js';
import * as Component_530 from '../components/v4/ui/Icons/credit_card.js';
import * as Component_531 from '../components/v4/ui/Icons/Elo.js';
import * as Component_532 from '../components/v4/ui/Icons/KmlIcon.js';
import * as Component_533 from '../components/v4/ui/Icons/MasterCard.js';
import * as Component_534 from '../components/v4/ui/Icons/Visa.js';
import * as Component_535 from '../components/v4/ui/Icons/WhatsApp.js';
import * as Component_536 from '../components/v4/ui/LoadingComponent/index.js';
import * as Component_537 from '../components/v4/ui/LoadingComponent/styles.js';
import * as Component_538 from '../components/v4/ui/MarkdownEditor/Index.js';
import * as Component_539 from '../components/v4/ui/MarkdownEditor/styles.js';
import * as Component_540 from '../components/v4/ui/NavBar/index.js';
import * as Component_541 from '../components/v4/ui/NavBar/Logo/index.js';
import * as Component_542 from '../components/v4/ui/NavBar/RightGroupMenu/AdminMenu/index.js';
import * as Component_543 from '../components/v4/ui/NavBar/RightGroupMenu/AdminMenu/styles.js';
import * as Component_544 from '../components/v4/ui/NavBar/RightGroupMenu/Alert/index.js';
import * as Component_545 from '../components/v4/ui/NavBar/RightGroupMenu/Alert/styles.js';
import * as Component_546 from '../components/v4/ui/NavBar/RightGroupMenu/index.js';
import * as Component_547 from '../components/v4/ui/NavBar/RightGroupMenu/Notifications/dialogs.js';
import * as Component_548 from '../components/v4/ui/NavBar/RightGroupMenu/Notifications/index.js';
import * as Component_549 from '../components/v4/ui/NavBar/RightGroupMenu/Notifications/NotificationCard.js';
import * as Component_550 from '../components/v4/ui/NavBar/RightGroupMenu/Notifications/styles.js';
import * as Component_551 from '../components/v4/ui/NavBar/RightGroupMenu/OrganizationsMenu/index.js';
import * as Component_552 from '../components/v4/ui/NavBar/RightGroupMenu/OrganizationsMenu/OrganizationsList/index.js';
import * as Component_553 from '../components/v4/ui/NavBar/RightGroupMenu/OrganizationsMenu/SelectedOrganization/index.js';
import * as Component_554 from '../components/v4/ui/NavBar/RightGroupMenu/OrganizationsMenu/styles.js';
import * as Component_555 from '../components/v4/ui/NavBar/RightGroupMenu/ProductsMenu/index.js';
import * as Component_556 from '../components/v4/ui/NavBar/RightGroupMenu/ProductsMenu/ProductsList.js';
import * as Component_557 from '../components/v4/ui/NavBar/RightGroupMenu/ProductsMenu/styles.js';
import * as Component_558 from '../components/v4/ui/NavBar/RightGroupMenu/styles.js';
import * as Component_559 from '../components/v4/ui/NavBar/RightGroupMenu/SupportMenu/index.js';
import * as Component_560 from '../components/v4/ui/NavBar/RightGroupMenu/SupportMenu/styles.js';
import * as Component_561 from '../components/v4/ui/NavBar/styles.js';
import * as Component_562 from '../components/v4/ui/NotificationsDialogs/advancePhenological.js';
import * as Component_563 from '../components/v4/ui/NotificationsDialogs/depthDelayed.js';
import * as Component_564 from '../components/v4/ui/NotificationsDialogs/RegisterCrop.js';
import * as Component_565 from '../components/v4/ui/SideBar/index.js';
import * as Component_566 from '../components/v4/ui/SideBar/styles.js';
import * as Component_567 from '../components/v4/ui/SimpleFields/Telephone/index.js';
import * as Component_568 from '../components/v4/ui/SimpleFields/TextField/index.js';
import * as Component_569 from '../components/v4/ui/SimpleFields/TextFieldWithIcon/index.js';
import * as Component_570 from '../components/v4/ui/SimpleSelect/index.js';
import * as Component_571 from '../components/v4/ui/SimpleSelect/styles.js';
import * as Component_572 from '../components/v4/ui/Stepper/index.js';
import * as Component_573 from '../components/v4/ui/Stepper/styles.js';
import * as Component_574 from '../components/v4/ui/Store/Cart/empty.js';
import * as Component_575 from '../components/v4/ui/Store/Cart/index.js';
import * as Component_576 from '../components/v4/ui/Store/Cart/list.js';
import * as Component_577 from '../components/v4/ui/Store/Cart/styles.js';
import * as Component_578 from '../components/v4/ui/Table/index.js';
import * as Component_579 from '../components/v4/ui/UserUnconfirmedWarning/index.js';
import * as Component_580 from '../components/v4/ui/UserUnconfirmedWarning/styles.js';
import * as Component_581 from '../components/v4/ui/WindDirection/index.js';
import * as Component_582 from '../components/v4/user_privacy_policies/Index.js';
import * as Component_583 from '../components/v4/user_terms/Index.js';
import * as Component_584 from '../components/v4/weather_forecasts/charts/AccumulatedRain/AccumulatedRainChart.js';
import * as Component_585 from '../components/v4/weather_forecasts/charts/AccumulatedRain/Legend.js';
import * as Component_586 from '../components/v4/weather_forecasts/charts/AccumulatedRain/Tooltip.js';
import * as Component_587 from '../components/v4/weather_forecasts/charts/Charts.js';
import * as Component_588 from '../components/v4/weather_forecasts/charts/Default/DefaultChart.js';
import * as Component_589 from '../components/v4/weather_forecasts/charts/ToolTip.js';
import * as Component_590 from '../components/v4/weather_forecasts/charts/WindVelocity/Dot.js';
import * as Component_591 from '../components/v4/weather_forecasts/charts/WindVelocity/Tooltip.js';
import * as Component_592 from '../components/v4/weather_forecasts/charts/WindVelocity/WindVelocityChart.js';
import * as Component_593 from '../components/v4/weather_forecasts/Dashboard.js';
import * as Component_594 from '../components/v4/weather_forecasts/DashboardCharts.js';
import * as Component_595 from '../components/v4/weather_forecasts/DashboardTable.js';
import * as Component_596 from '../components/v4/weather_forecasts/ForecastWrapper.js';
import * as Component_597 from '../components/v4/weather_forecasts/Header/index.js';
import * as Component_598 from '../components/v4/weather_forecasts/Index.js';
import * as Component_599 from '../components/v4/weather_forecasts/PreviewSetting/index.js';
import * as Component_600 from '../components/v4/weather_forecasts/PreviewSetting/PreviewMode.js';
import * as Component_601 from '../components/v4/weather_forecasts/PreviewSetting/Switch.js';
import * as Component_602 from '../components/v4/weather_forecasts/styles.js';
import * as Component_603 from '../components/v4/weather_forecasts/Table/index.js';
import * as Component_604 from '../components/v4/widgets/Card/BatteryStatus.js';
import * as Component_605 from '../components/v4/widgets/Card/Card.js';
import * as Component_606 from '../components/v4/widgets/Card/CardWithDepth.js';
import * as Component_607 from '../components/v4/widgets/Card/CardWithoutDepth.js';
import * as Component_608 from '../components/v4/widgets/Card/DateAndTime.js';
import * as Component_609 from '../components/v4/widgets/Card/Offline.js';
import * as Component_610 from '../components/v4/widgets/Card/TelemetryButton.js';
import * as Component_611 from '../components/v4/widgets/Index.js';
import * as Component_612 from '../components/v4/widgets/NoEquipments.js';

// Components map compatible with createComponentContext
// Structure matches import.meta.glob output: { path: module }
const components = {
  '../components/v4/accounts/Edit.js': Component_0,
  '../components/v4/accounts/Form.js': Component_1,
  '../components/v4/accounts/New.js': Component_2,
  '../components/v4/accounts/OrganizationList.js': Component_3,
  '../components/v4/accounts/TabPanel.js': Component_4,
  '../components/v4/admin/dashboard/Index.js': Component_5,
  '../components/v4/admin/dashboard/MainMenu.js': Component_6,
  '../components/v4/admin/dashboard/ReportsMenu.js': Component_7,
  '../components/v4/admin/dashboard/RouterOutlet.js': Component_8,
  '../components/v4/admin/equipment_measures/Audits.js': Component_9,
  '../components/v4/admin/equipment_measures/DeleteMeasureDialog.js': Component_10,
  '../components/v4/admin/equipment_measures/Edit.js': Component_11,
  '../components/v4/admin/equipment_measures/Form.js': Component_12,
  '../components/v4/admin/equipment_measures/Index.js': Component_13,
  '../components/v4/admin/equipment_measures/New.js': Component_14,
  '../components/v4/admin/hardware_products/Edit.js': Component_15,
  '../components/v4/admin/hardware_products/Form.js': Component_16,
  '../components/v4/admin/hardware_products/Index.js': Component_17,
  '../components/v4/admin/hardware_products/New.js': Component_18,
  '../components/v4/admin/hardware_products/Show.js': Component_19,
  '../components/v4/admin/organizations/alerts/Edit.js': Component_20,
  '../components/v4/admin/organizations/alerts/Form.js': Component_21,
  '../components/v4/admin/organizations/alerts/Index.js': Component_22,
  '../components/v4/admin/organizations/alerts/Show.js': Component_23,
  '../components/v4/admin/organizations/assets/AcquisitionTypeDialog.js': Component_24,
  '../components/v4/admin/organizations/assets/Index.js': Component_25,
  '../components/v4/admin/organizations/assets/Timeline.js': Component_26,
  '../components/v4/admin/organizations/contacts/Edit.js': Component_27,
  '../components/v4/admin/organizations/contacts/Form.js': Component_28,
  '../components/v4/admin/organizations/contacts/Index.js': Component_29,
  '../components/v4/admin/organizations/contacts/New.js': Component_30,
  '../components/v4/admin/organizations/Edit.js': Component_31,
  '../components/v4/admin/organizations/Form.js': Component_32,
  '../components/v4/admin/organizations/Index.js': Component_33,
  '../components/v4/admin/organizations/New.js': Component_34,
  '../components/v4/admin/organizations/organization_products/alert/product_configs/AlertSettings.js': Component_35,
  '../components/v4/admin/organizations/organization_products/alert/product_configs/Form.js': Component_36,
  '../components/v4/admin/organizations/organization_products/Edit.js': Component_37,
  '../components/v4/admin/organizations/organization_products/EditForm.js': Component_38,
  '../components/v4/admin/organizations/organization_products/field_notebook/DialogForm.js': Component_39,
  '../components/v4/admin/organizations/organization_products/field_notebook/Edit.js': Component_40,
  '../components/v4/admin/organizations/organization_products/field_notebook/Form.js': Component_41,
  '../components/v4/admin/organizations/organization_products/forecast/points/EditForm.js': Component_42,
  '../components/v4/admin/organizations/organization_products/forecast/points/Index.js': Component_43,
  '../components/v4/admin/organizations/organization_products/forecast/points/Points.js': Component_44,
  '../components/v4/admin/organizations/organization_products/forecast/points/Show.js': Component_45,
  '../components/v4/admin/organizations/organization_products/forecast/points/styles.js': Component_46,
  '../components/v4/admin/organizations/organization_products/forecast/points/TableForm.js': Component_47,
  '../components/v4/admin/organizations/organization_products/Form.js': Component_48,
  '../components/v4/admin/organizations/organization_products/Index.js': Component_49,
  '../components/v4/admin/organizations/organization_products/insight/DialogForm.js': Component_50,
  '../components/v4/admin/organizations/organization_products/insight/Edit.js': Component_51,
  '../components/v4/admin/organizations/organization_products/insight/Form.js': Component_52,
  '../components/v4/admin/organizations/organization_products/irrigation_management/Edit.js': Component_53,
  '../components/v4/admin/organizations/organization_products/irrigation_management/Form.js': Component_54,
  '../components/v4/admin/organizations/organization_products/New.js': Component_55,
  '../components/v4/admin/organizations/organization_products/notifications/weather_forecast/Index.js': Component_56,
  '../components/v4/admin/organizations/organization_products/satellite_imagery/Edit.js': Component_57,
  '../components/v4/admin/organizations/organization_products/satellite_imagery/Form.js': Component_58,
  '../components/v4/admin/organizations/Show.js': Component_59,
  '../components/v4/admin/organizations/subscriptions/Index.js': Component_60,
  '../components/v4/admin/organizations/users/Edit.js': Component_61,
  '../components/v4/admin/organizations/users/EditForm.js': Component_62,
  '../components/v4/admin/organizations/users/Index.js': Component_63,
  '../components/v4/admin/organizations/users/NewForm.js': Component_64,
  '../components/v4/admin/organizations/users/NewInvitation.js': Component_65,
  '../components/v4/admin/organizations/users/Show.js': Component_66,
  '../components/v4/admin/part_number_registries/Edit.js': Component_67,
  '../components/v4/admin/part_number_registries/Form.js': Component_68,
  '../components/v4/admin/part_number_registries/Index.js': Component_69,
  '../components/v4/admin/part_number_registries/New.js': Component_70,
  '../components/v4/admin/part_number_registries/Show.js': Component_71,
  '../components/v4/admin/part_number_registries/styles.js': Component_72,
  '../components/v4/admin/part_number_registries/stylesShow.js': Component_73,
  '../components/v4/admin/privacy_policies/Edit.js': Component_74,
  '../components/v4/admin/privacy_policies/Form.js': Component_75,
  '../components/v4/admin/privacy_policies/Index.js': Component_76,
  '../components/v4/admin/privacy_policies/New.js': Component_77,
  '../components/v4/admin/products/Edit.js': Component_78,
  '../components/v4/admin/products/Form.js': Component_79,
  '../components/v4/admin/products/Index.js': Component_80,
  '../components/v4/admin/products/New.js': Component_81,
  '../components/v4/admin/products/ParamsTable.js': Component_82,
  '../components/v4/admin/products/Show.js': Component_83,
  '../components/v4/admin/reports/ClimateReport.js': Component_84,
  '../components/v4/admin/reports/IrrigationReport.js': Component_85,
  '../components/v4/admin/reports/SatelliteImageReport.js': Component_86,
  '../components/v4/admin/sensor_configs/Edit.js': Component_87,
  '../components/v4/admin/sensor_configs/Form.js': Component_88,
  '../components/v4/admin/sensor_configs/Index.js': Component_89,
  '../components/v4/admin/sensor_configs/New.js': Component_90,
  '../components/v4/admin/sensor_configs/Show.js': Component_91,
  '../components/v4/admin/sensor_configs/style.js': Component_92,
  '../components/v4/admin/sensors/Edit.js': Component_93,
  '../components/v4/admin/sensors/Form.js': Component_94,
  '../components/v4/admin/sensors/Index.js': Component_95,
  '../components/v4/admin/sensors/New.js': Component_96,
  '../components/v4/admin/sensors/ParamsTable.js': Component_97,
  '../components/v4/admin/sensors/Show.js': Component_98,
  '../components/v4/admin/tenants/ColorsForm/BackgroundColorForm.js': Component_99,
  '../components/v4/admin/tenants/ColorsForm/BarsColorsForm.js': Component_100,
  '../components/v4/admin/tenants/ColorsForm/DefaultColorsForm.js': Component_101,
  '../components/v4/admin/tenants/ColorsForm/Index.js': Component_102,
  '../components/v4/admin/tenants/ColorsForm/MainColorsForm.js': Component_103,
  '../components/v4/admin/tenants/ColorsForm/PaperBackgroundColorForm.js': Component_104,
  '../components/v4/admin/tenants/ColorsForm/PrimaryTextForm.js': Component_105,
  '../components/v4/admin/tenants/ColorsForm/SecondaryTextForm.js': Component_106,
  '../components/v4/admin/tenants/ColorsForm/style.js': Component_107,
  '../components/v4/admin/tenants/Edit.js': Component_108,
  '../components/v4/admin/tenants/EmailConfigurationForm/index.js': Component_109,
  '../components/v4/admin/tenants/Form.js': Component_110,
  '../components/v4/admin/tenants/Index.js': Component_111,
  '../components/v4/admin/tenants/LoginScreenForm/Index.js': Component_112,
  '../components/v4/admin/tenants/LoginScreenForm/LoginScreenPreview.js': Component_113,
  '../components/v4/admin/tenants/New.js': Component_114,
  '../components/v4/admin/tenants/Steppers/index.js': Component_115,
  '../components/v4/admin/tenants/Steppers/style.js': Component_116,
  '../components/v4/admin/tenants/TenantPreview/FormPreview.js': Component_117,
  '../components/v4/admin/tenants/TenantPreview/index.js': Component_118,
  '../components/v4/admin/tenants/TenantPreview/NavBarPreview.js': Component_119,
  '../components/v4/admin/tenants/TenantPreview/PreviewScreen.js': Component_120,
  '../components/v4/admin/tenants/TenantPreview/previewStyles.js': Component_121,
  '../components/v4/admin/tenants/TenantPreview/SideBarPreview.js': Component_122,
  '../components/v4/admin/tenants/terms/Edit.js': Component_123,
  '../components/v4/admin/tenants/terms/Form.js': Component_124,
  '../components/v4/admin/tenants/terms/Index.js': Component_125,
  '../components/v4/admin/tenants/terms/New.js': Component_126,
  '../components/v4/admin/tenants/users/Edit.js': Component_127,
  '../components/v4/admin/tenants/users/Form.js': Component_128,
  '../components/v4/admin/tenants/users/Index.js': Component_129,
  '../components/v4/admin/tenants/users/New.js': Component_130,
  '../components/v4/admin/tenants/users/Show.js': Component_131,
  '../components/v4/alerts/Edit.js': Component_132,
  '../components/v4/alerts/Filter.js': Component_133,
  '../components/v4/alerts/Index.js': Component_134,
  '../components/v4/alerts/new_alert/AlertNameStep.js': Component_135,
  '../components/v4/alerts/new_alert/AlertPreviewStep.js': Component_136,
  '../components/v4/alerts/new_alert/CreateAreaStep.js': Component_137,
  '../components/v4/alerts/new_alert/LandingStep.js': Component_138,
  '../components/v4/alerts/new_alert/MediaForm.js': Component_139,
  '../components/v4/alerts/new_alert/ReceiveAlert.js': Component_140,
  '../components/v4/alerts/new_alert/ReceiveAlertStep.js': Component_141,
  '../components/v4/alerts/new_alert/SelectAreaStep.js': Component_142,
  '../components/v4/alerts/new_alert/SelectEquipmentStep.js': Component_143,
  '../components/v4/alerts/new_alert/SelectVariablesStep.js': Component_144,
  '../components/v4/alerts/new_alert/SetValuesForVariablesStep.js': Component_145,
  '../components/v4/alerts/new_alert/Step.js': Component_146,
  '../components/v4/alerts/New.js': Component_147,
  '../components/v4/alerts/Stepper.js': Component_148,
  '../components/v4/alerts/styles.js': Component_149,
  '../components/v4/App.js': Component_150,
  '../components/v4/areas/analyses/AnalysesList.js': Component_151,
  '../components/v4/areas/analyses/ApiWrapper.js': Component_152,
  '../components/v4/areas/analyses/Form.js': Component_153,
  '../components/v4/areas/analyses/Index.js': Component_154,
  '../components/v4/areas/analyses/samples/Form.js': Component_155,
  '../components/v4/areas/analyses/samples/Index.js': Component_156,
  '../components/v4/areas/analyses/samples/Show.js': Component_157,
  '../components/v4/areas/analyses/samples/styles.js': Component_158,
  '../components/v4/areas/analyses/styles.js': Component_159,
  '../components/v4/areas/Dashboard.js': Component_160,
  '../components/v4/areas/dashboard/Index.js': Component_161,
  '../components/v4/areas/dashboard/InformProdutivity.js': Component_162,
  '../components/v4/areas/dashboard/LastPlantationsTable.js': Component_163,
  '../components/v4/areas/dashboard/NewPlantation.js': Component_164,
  '../components/v4/areas/dashboard/NewPlantationForm.js': Component_165,
  '../components/v4/areas/dashboard/NewPlantationFormWrapper.js': Component_166,
  '../components/v4/areas/dashboard/ShowProdutivity.js': Component_167,
  '../components/v4/areas/dashboard/styles.js': Component_168,
  '../components/v4/areas/Edit.js': Component_169,
  '../components/v4/areas/Form.js': Component_170,
  '../components/v4/areas/Index.js': Component_171,
  '../components/v4/areas/notes/AreaFields.js': Component_172,
  '../components/v4/areas/notes/Dialog.js': Component_173,
  '../components/v4/areas/notes/Form.js': Component_174,
  '../components/v4/areas/notes/FormWrapper.js': Component_175,
  '../components/v4/attachments/Index.js': Component_176,
  '../components/v4/checkout/BillingData.js': Component_177,
  '../components/v4/checkout/BillingDataForm.js': Component_178,
  '../components/v4/checkout/BillingInfo.js': Component_179,
  '../components/v4/checkout/CheckoutResume.js': Component_180,
  '../components/v4/checkout/CouponForm.js': Component_181,
  '../components/v4/checkout/CreditCard.js': Component_182,
  '../components/v4/checkout/Index.js': Component_183,
  '../components/v4/checkout/PersonalDataForm.js': Component_184,
  '../components/v4/checkout/styles.js': Component_185,
  '../components/v4/checkout/SuccessScreen.js': Component_186,
  '../components/v4/comparison/Filter.js': Component_187,
  '../components/v4/comparison/Index.js': Component_188,
  '../components/v4/comparison/Map.js': Component_189,
  '../components/v4/comparison/Maps.js': Component_190,
  '../components/v4/cultures/CultureForm.js': Component_191,
  '../components/v4/cultures/Edit.js': Component_192,
  '../components/v4/cultures/Form.js': Component_193,
  '../components/v4/cultures/Index.js': Component_194,
  '../components/v4/cultures/New.js': Component_195,
  '../components/v4/cultures/Show.js': Component_196,
  '../components/v4/cultures/stages/Form.js': Component_197,
  '../components/v4/cultures/stages/Index.js': Component_198,
  '../components/v4/cultures/stages/Show.js': Component_199,
  '../components/v4/cultures/stages/styles.js': Component_200,
  '../components/v4/equipments/Automatic/Edit.js': Component_201,
  '../components/v4/equipments/Automatic/Form.js': Component_202,
  '../components/v4/equipments/Automatic/New.js': Component_203,
  '../components/v4/equipments/Automatic/sensorConfiguration/Form.js': Component_204,
  '../components/v4/equipments/Automatic/sensorConfiguration/Index.js': Component_205,
  '../components/v4/equipments/Automatic/sensorConfiguration/Show.js': Component_206,
  '../components/v4/equipments/Automatic/sensorConfiguration/styles.js': Component_207,
  '../components/v4/equipments/Dashboard.js': Component_208,
  '../components/v4/equipments/dashboard/DashboardCharts.js': Component_209,
  '../components/v4/equipments/dashboard/DashboardTable.js': Component_210,
  '../components/v4/equipments/dashboard/Filter.js': Component_211,
  '../components/v4/equipments/dashboard/Index.js': Component_212,
  '../components/v4/equipments/dashboard/ModalCharts.js': Component_213,
  '../components/v4/equipments/dashboard/styles.js': Component_214,
  '../components/v4/equipments/Edit.js': Component_215,
  '../components/v4/equipments/Form.js': Component_216,
  '../components/v4/equipments/Implements/Edit.js': Component_217,
  '../components/v4/equipments/Implements/Form.js': Component_218,
  '../components/v4/equipments/Implements/New.js': Component_219,
  '../components/v4/equipments/Index.js': Component_220,
  '../components/v4/equipments/irrigations/AreaFields.js': Component_221,
  '../components/v4/equipments/irrigations/BoundedGraphic.js': Component_222,
  '../components/v4/equipments/irrigations/Dialog.js': Component_223,
  '../components/v4/equipments/irrigations/Edit.js': Component_224,
  '../components/v4/equipments/irrigations/EditForm.js': Component_225,
  '../components/v4/equipments/irrigations/Form.js': Component_226,
  '../components/v4/equipments/irrigations/FormWrapper.js': Component_227,
  '../components/v4/equipments/irrigations/Index.js': Component_228,
  '../components/v4/equipments/irrigations/InformIrrigation.js': Component_229,
  '../components/v4/equipments/irrigations/New.js': Component_230,
  '../components/v4/equipments/irrigations/PivotGraphic.js': Component_231,
  '../components/v4/equipments/IrrigationSystem/BoundedForm.js': Component_232,
  '../components/v4/equipments/IrrigationSystem/CalculationResultInfo.js': Component_233,
  '../components/v4/equipments/IrrigationSystem/Edit.js': Component_234,
  '../components/v4/equipments/IrrigationSystem/Form.js': Component_235,
  '../components/v4/equipments/IrrigationSystem/New.js': Component_236,
  '../components/v4/equipments/IrrigationSystem/PivotForm.js': Component_237,
  '../components/v4/equipments/Manual/Edit.js': Component_238,
  '../components/v4/equipments/Manual/Form.js': Component_239,
  '../components/v4/equipments/Manual/New.js': Component_240,
  '../components/v4/equipments/measures/DashboardTable.js': Component_241,
  '../components/v4/equipments/measures/FilterForm.js': Component_242,
  '../components/v4/equipments/measures/Header.js': Component_243,
  '../components/v4/equipments/measures/Index.js': Component_244,
  '../components/v4/equipments/measures/ModalForm.js': Component_245,
  '../components/v4/equipments/New.js': Component_246,
  '../components/v4/equipments/Show.js': Component_247,
  '../components/v4/equipments/Tractor/Edit.js': Component_248,
  '../components/v4/equipments/Tractor/Form.js': Component_249,
  '../components/v4/equipments/Tractor/New.js': Component_250,
  '../components/v4/errors/Index.js': Component_251,
  '../components/v4/errors/styles.js': Component_252,
  '../components/v4/field_notebooks/Card.js': Component_253,
  '../components/v4/field_notebooks/CardContent.js': Component_254,
  '../components/v4/field_notebooks/CardRedirectToMobile.js': Component_255,
  '../components/v4/field_notebooks/Header.js': Component_256,
  '../components/v4/field_notebooks/Index.js': Component_257,
  '../components/v4/forecast-cards/card.js': Component_258,
  '../components/v4/forecast-cards/forecast-point-form.js': Component_259,
  '../components/v4/forecast-cards/forecast-resume.js': Component_260,
  '../components/v4/forecast-cards/forecast.js': Component_261,
  '../components/v4/forecast-cards/Index.js': Component_262,
  '../components/v4/forecast-cards/styles.js': Component_263,
  '../components/v4/index.js': Component_264,
  '../components/v4/inputs/chemicals/Edit.js': Component_265,
  '../components/v4/inputs/chemicals/Form.js': Component_266,
  '../components/v4/inputs/chemicals/New.js': Component_267,
  '../components/v4/inputs/cultivar/Edit.js': Component_268,
  '../components/v4/inputs/cultivar/Form.js': Component_269,
  '../components/v4/inputs/cultivar/New.js': Component_270,
  '../components/v4/inputs/Edit.js': Component_271,
  '../components/v4/inputs/fertilizers/Edit.js': Component_272,
  '../components/v4/inputs/fertilizers/Form.js': Component_273,
  '../components/v4/inputs/fertilizers/New.js': Component_274,
  '../components/v4/inputs/Form.js': Component_275,
  '../components/v4/inputs/Index.js': Component_276,
  '../components/v4/inputs/New.js': Component_277,
  '../components/v4/inputs/others/Edit.js': Component_278,
  '../components/v4/inputs/others/Form.js': Component_279,
  '../components/v4/inputs/others/New.js': Component_280,
  '../components/v4/inputs/Show.js': Component_281,
  '../components/v4/insights/Index.js': Component_282,
  '../components/v4/irrigation_managements/ButtonArea.js': Component_283,
  '../components/v4/irrigation_managements/Dashboard.js': Component_284,
  '../components/v4/irrigation_managements/Edit.js': Component_285,
  '../components/v4/irrigation_managements/Form.js': Component_286,
  '../components/v4/irrigation_managements/form/AdvancedParams/AvailableWater.js': Component_287,
  '../components/v4/irrigation_managements/form/AdvancedParams/CorrectionFactor.js': Component_288,
  '../components/v4/irrigation_managements/form/AdvancedParams/index.js': Component_289,
  '../components/v4/irrigation_managements/form/AdvancedParams/Panel.js': Component_290,
  '../components/v4/irrigation_managements/form/AdvancedParams/RootDepth.js': Component_291,
  '../components/v4/irrigation_managements/form/AdvancedParams/Table.js': Component_292,
  '../components/v4/irrigation_managements/form/AdvancedParamsDialog.js': Component_293,
  '../components/v4/irrigation_managements/form/AreaFields.js': Component_294,
  '../components/v4/irrigation_managements/form/CustomField.js': Component_295,
  '../components/v4/irrigation_managements/form/ForecastPoint/Form.js': Component_296,
  '../components/v4/irrigation_managements/form/ForecastPoint/index.js': Component_297,
  '../components/v4/irrigation_managements/Index.js': Component_298,
  '../components/v4/irrigation_managements/inform.js': Component_299,
  '../components/v4/irrigation_managements/New.js': Component_300,
  '../components/v4/irrigation_managements/styles.js': Component_301,
  '../components/v4/irrigation/management/chartLegend/index.js': Component_302,
  '../components/v4/irrigation/management/chartLegend/styles.js': Component_303,
  '../components/v4/irrigation/management/chartTooltip/index.js': Component_304,
  '../components/v4/irrigation/management/chartTooltip/styles.js': Component_305,
  '../components/v4/irrigation/management/dataSummaryCard/index.js': Component_306,
  '../components/v4/irrigation/management/dataSummaryCard/styles.js': Component_307,
  '../components/v4/irrigation/management/eventsMap/customizedDotHandler/index.js': Component_308,
  '../components/v4/irrigation/management/eventsMap/eventsMapLegend/index.js': Component_309,
  '../components/v4/irrigation/management/eventsMap/eventsMapTooltip/index.js': Component_310,
  '../components/v4/irrigation/management/eventsMap/index.js': Component_311,
  '../components/v4/irrigation/management/hydricStatus/index.js': Component_312,
  '../components/v4/irrigation/management/index.js': Component_313,
  '../components/v4/irrigation/management/irrigationChart/ChartsGenerator/ChartsGenerator.js': Component_314,
  '../components/v4/irrigation/management/irrigationChart/index.js': Component_315,
  '../components/v4/irrigation/management/irrigationChart/irrigationChartLegend/index.js': Component_316,
  '../components/v4/irrigation/management/irrigationChart/PhenologicalStageReferenceLabel.js': Component_317,
  '../components/v4/irrigation/management/irrigationChart/styles.js': Component_318,
  '../components/v4/irrigation/management/irrigationManagementContent/index.js': Component_319,
  '../components/v4/irrigation/management/irrigationManagementNavBar/index.js': Component_320,
  '../components/v4/irrigation/management/irrigationManagementNavBar/managementDescription.js': Component_321,
  '../components/v4/irrigation/management/irrigationManagementNavBar/managementDisplayOption.js': Component_322,
  '../components/v4/login/AppleIcon.js': Component_323,
  '../components/v4/login/ConfirmEmailDialog/ContentBody.js': Component_324,
  '../components/v4/login/ConfirmEmailDialog/ContentControl.js': Component_325,
  '../components/v4/login/ConfirmEmailDialog/Index.js': Component_326,
  '../components/v4/login/ConfirmEmailDialog/styles.js': Component_327,
  '../components/v4/login/ConfirmInviteScreen.js': Component_328,
  '../components/v4/login/DeviseScreen.js': Component_329,
  '../components/v4/login/EditPassword.js': Component_330,
  '../components/v4/login/Login.js': Component_331,
  '../components/v4/login/MicrosoftIcon.js': Component_332,
  '../components/v4/login/RetrievePassword.js': Component_333,
  '../components/v4/login/SelectLocale.js': Component_334,
  '../components/v4/login/SignUp.js': Component_335,
  '../components/v4/login/styles.js': Component_336,
  '../components/v4/maps/Controls/Control.js': Component_337,
  '../components/v4/maps/Controls/index.js': Component_338,
  '../components/v4/maps/Index.js': Component_339,
  '../components/v4/maps/infoMenu/Alerts/index.js': Component_340,
  '../components/v4/maps/infoMenu/Area/Action.js': Component_341,
  '../components/v4/maps/infoMenu/Area/CancelHarvest.js': Component_342,
  '../components/v4/maps/infoMenu/Area/CropContent.js': Component_343,
  '../components/v4/maps/infoMenu/Area/EditArea.js': Component_344,
  '../components/v4/maps/infoMenu/Area/ExpiredPhase.js': Component_345,
  '../components/v4/maps/infoMenu/Area/FormCrop.js': Component_346,
  '../components/v4/maps/infoMenu/Area/index.js': Component_347,
  '../components/v4/maps/infoMenu/Area/Intercom.js': Component_348,
  '../components/v4/maps/infoMenu/Area/ProductsContent.js': Component_349,
  '../components/v4/maps/infoMenu/Area/ViewProduct.js': Component_350,
  '../components/v4/maps/infoMenu/AreaInfo.js': Component_351,
  '../components/v4/maps/infoMenu/Equipment/Action.js': Component_352,
  '../components/v4/maps/infoMenu/Equipment/Battery.js': Component_353,
  '../components/v4/maps/infoMenu/Equipment/DepthTable.js': Component_354,
  '../components/v4/maps/infoMenu/Equipment/EquipmentSelect.js': Component_355,
  '../components/v4/maps/infoMenu/Equipment/index.js': Component_356,
  '../components/v4/maps/infoMenu/Equipment/InfoDate.js': Component_357,
  '../components/v4/maps/infoMenu/Equipment/Installed.js': Component_358,
  '../components/v4/maps/infoMenu/Equipment/Offline.js': Component_359,
  '../components/v4/maps/infoMenu/Equipment/Support.js': Component_360,
  '../components/v4/maps/infoMenu/Equipment/Uninstalled.js': Component_361,
  '../components/v4/maps/infoMenu/Equipment/Unknown.js': Component_362,
  '../components/v4/maps/infoMenu/Equipment/Variables.js': Component_363,
  '../components/v4/maps/infoMenu/Hydrometer/Action.js': Component_364,
  '../components/v4/maps/infoMenu/Hydrometer/Body.js': Component_365,
  '../components/v4/maps/infoMenu/Hydrometer/CustomOdometer/index.js': Component_366,
  '../components/v4/maps/infoMenu/Hydrometer/CustomOdometer/OdometerDigit.js': Component_367,
  '../components/v4/maps/infoMenu/Hydrometer/Form.js': Component_368,
  '../components/v4/maps/infoMenu/Hydrometer/Header.js': Component_369,
  '../components/v4/maps/infoMenu/Hydrometer/HoursTabs.js': Component_370,
  '../components/v4/maps/infoMenu/Hydrometer/index.js': Component_371,
  '../components/v4/maps/infoMenu/Hydrometer/WrapperOdometer.js': Component_372,
  '../components/v4/maps/infoMenu/Index.js': Component_373,
  '../components/v4/maps/infoMenu/InfoMenu.js': Component_374,
  '../components/v4/maps/infoMenu/InfoMenuWrapper.js': Component_375,
  '../components/v4/maps/infoMenu/ManualEquipment/Form.js': Component_376,
  '../components/v4/maps/infoMenu/ManualEquipment/index.js': Component_377,
  '../components/v4/maps/infoMenu/ManualEquipment/InfoRain.js': Component_378,
  '../components/v4/maps/infoMenu/ManualEquipment/RainHistory.js': Component_379,
  '../components/v4/maps/infoMenu/styles.js': Component_380,
  '../components/v4/maps/IrrigationManagement/Cards/Card.js': Component_381,
  '../components/v4/maps/IrrigationManagement/Cards/CurrentIrrigationCard.js': Component_382,
  '../components/v4/maps/IrrigationManagement/Cards/IrrigationForecastCard.js': Component_383,
  '../components/v4/maps/IrrigationManagement/Cards/LegendCard.js': Component_384,
  '../components/v4/maps/IrrigationManagement/Cards/ResumeCard.js': Component_385,
  '../components/v4/maps/IrrigationManagement/index.js': Component_386,
  '../components/v4/maps/Map.js': Component_387,
  '../components/v4/maps/MapColorsLegend.js': Component_388,
  '../components/v4/maps/NewAreaDialog.js': Component_389,
  '../components/v4/maps/NewAreaFileForm.js': Component_390,
  '../components/v4/maps/NewAreaForm.js': Component_391,
  '../components/v4/maps/NewAreasTable.js': Component_392,
  '../components/v4/maps/products/Index.js': Component_393,
  '../components/v4/maps/products/styles.js': Component_394,
  '../components/v4/maps/productsFloatingMenu/Atmos/ApplicationCondition/Application.js': Component_395,
  '../components/v4/maps/productsFloatingMenu/Atmos/ApplicationCondition/ConditionDays.js': Component_396,
  '../components/v4/maps/productsFloatingMenu/Atmos/ApplicationCondition/index.js': Component_397,
  '../components/v4/maps/productsFloatingMenu/Atmos/Body.js': Component_398,
  '../components/v4/maps/productsFloatingMenu/Atmos/Card.js': Component_399,
  '../components/v4/maps/productsFloatingMenu/Atmos/EmptyData.js': Component_400,
  '../components/v4/maps/productsFloatingMenu/Atmos/Footer.js': Component_401,
  '../components/v4/maps/productsFloatingMenu/Atmos/Header.js': Component_402,
  '../components/v4/maps/productsFloatingMenu/Atmos/Index.js': Component_403,
  '../components/v4/maps/productsFloatingMenu/Atmos/SetupNewForecastPoint/Dialog.js': Component_404,
  '../components/v4/maps/productsFloatingMenu/Atmos/SetupNewForecastPoint/FpNameForm.js': Component_405,
  '../components/v4/maps/productsFloatingMenu/Atmos/SetupNewForecastPoint/Index.js': Component_406,
  '../components/v4/maps/productsFloatingMenu/Atmos/SetupNewForecastPoint/LatLongForm.js': Component_407,
  '../components/v4/maps/productsFloatingMenu/Atmos/SetupNewForecastPoint/Selector.js': Component_408,
  '../components/v4/maps/productsFloatingMenu/Atmos/Wrapper.js': Component_409,
  '../components/v4/maps/productsFloatingMenu/EditAreaMenu/Action.js': Component_410,
  '../components/v4/maps/productsFloatingMenu/EditAreaMenu/index.js': Component_411,
  '../components/v4/maps/productsFloatingMenu/ExpiredProductCard.js': Component_412,
  '../components/v4/maps/productsFloatingMenu/Index.js': Component_413,
  '../components/v4/maps/productsFloatingMenu/IrrigationManagement/Cards/Card.js': Component_414,
  '../components/v4/maps/productsFloatingMenu/IrrigationManagement/Cards/IrrigationForecastCard.js': Component_415,
  '../components/v4/maps/productsFloatingMenu/IrrigationManagement/Cards/LegendCard.js': Component_416,
  '../components/v4/maps/productsFloatingMenu/IrrigationManagement/Cards/ResumeCard.js': Component_417,
  '../components/v4/maps/productsFloatingMenu/IrrigationManagement/Header.js': Component_418,
  '../components/v4/maps/productsFloatingMenu/IrrigationManagement/index.js': Component_419,
  '../components/v4/maps/productsFloatingMenu/ProductsWrapper.js': Component_420,
  '../components/v4/maps/productsFloatingMenu/View/CardCreateArea.js': Component_421,
  '../components/v4/maps/productsFloatingMenu/View/ColorsLegend.js': Component_422,
  '../components/v4/maps/productsFloatingMenu/View/FilterForm.js': Component_423,
  '../components/v4/maps/productsFloatingMenu/View/FooterMenu.js': Component_424,
  '../components/v4/maps/productsFloatingMenu/View/Index.js': Component_425,
  '../components/v4/maps/productsFloatingMenu/View/SampleCard.js': Component_426,
  '../components/v4/maps/productsFloatingMenu/View/Tabs.js': Component_427,
  '../components/v4/maps/SatelliteImages/FilterForm.js': Component_428,
  '../components/v4/maps/SatelliteImages/Index.js': Component_429,
  '../components/v4/maps/SatelliteImages/SampleCard.js': Component_430,
  '../components/v4/maps/SatelliteImages/styles.js': Component_431,
  '../components/v4/maps/search/Index.js': Component_432,
  '../components/v4/maps/styles.js': Component_433,
  '../components/v4/notification_center/Index.js': Component_434,
  '../components/v4/notification_center/styles.js': Component_435,
  '../components/v4/notifications/Form.js': Component_436,
  '../components/v4/notifications/Index.js': Component_437,
  '../components/v4/notifications/styles.js': Component_438,
  '../components/v4/organizations/billing_info/Edit.js': Component_439,
  '../components/v4/organizations/billing_info/Form.js': Component_440,
  '../components/v4/organizations/Edit.js': Component_441,
  '../components/v4/organizations/Form.js': Component_442,
  '../components/v4/organizations/Index.js': Component_443,
  '../components/v4/organizations/invoices/Index.js': Component_444,
  '../components/v4/organizations/invoices/styles.js': Component_445,
  '../components/v4/organizations/New.js': Component_446,
  '../components/v4/organizations/payment_profiles/Form.js': Component_447,
  '../components/v4/organizations/payment_profiles/Index.js': Component_448,
  '../components/v4/organizations/payment_profiles/New.js': Component_449,
  '../components/v4/organizations/PaymentInfoTabs.js': Component_450,
  '../components/v4/organizations/Show.js': Component_451,
  '../components/v4/organizations/subscriptions/Edit.js': Component_452,
  '../components/v4/organizations/subscriptions/Form.js': Component_453,
  '../components/v4/organizations/subscriptions/Index.js': Component_454,
  '../components/v4/organizations/users/Form.js': Component_455,
  '../components/v4/organizations/users/Index.js': Component_456,
  '../components/v4/organizations/users/NewInvitation.js': Component_457,
  '../components/v4/organizations/users/Show.js': Component_458,
  '../components/v4/seasons/Dashboard/index.js': Component_459,
  '../components/v4/seasons/Edit.js': Component_460,
  '../components/v4/seasons/Form.js': Component_461,
  '../components/v4/seasons/Index.js': Component_462,
  '../components/v4/seasons/New.js': Component_463,
  '../components/v4/seasons/Show.js': Component_464,
  '../components/v4/seasons/styles.js': Component_465,
  '../components/v4/store/admin/coupons/Edit.js': Component_466,
  '../components/v4/store/admin/coupons/Form.js': Component_467,
  '../components/v4/store/admin/coupons/Index.js': Component_468,
  '../components/v4/store/admin/coupons/New.js': Component_469,
  '../components/v4/store/admin/coupons/plans_products/Form.js': Component_470,
  '../components/v4/store/admin/coupons/plans_products/Index.js': Component_471,
  '../components/v4/store/admin/plans/Edit.js': Component_472,
  '../components/v4/store/admin/plans/Form.js': Component_473,
  '../components/v4/store/admin/plans/Index.js': Component_474,
  '../components/v4/store/admin/plans/New.js': Component_475,
  '../components/v4/store/catalogs/Card.js': Component_476,
  '../components/v4/store/catalogs/Checkout.js': Component_477,
  '../components/v4/store/catalogs/Index.js': Component_478,
  '../components/v4/store/catalogs/Navbar.js': Component_479,
  '../components/v4/store/catalogs/Show.js': Component_480,
  '../components/v4/store/catalogs/Store.js': Component_481,
  '../components/v4/store/catalogs/styles.js': Component_482,
  '../components/v4/ui/ActionDialog/index.js': Component_483,
  '../components/v4/ui/AreaChangeHandler/index.js': Component_484,
  '../components/v4/ui/Banner/index.js': Component_485,
  '../components/v4/ui/Button/index.js': Component_486,
  '../components/v4/ui/ButtonGroup/index.js': Component_487,
  '../components/v4/ui/ButtonGroup/styles.js': Component_488,
  '../components/v4/ui/Charts/index.js': Component_489,
  '../components/v4/ui/Charts/styles.js': Component_490,
  '../components/v4/ui/Charts/tooltip.js': Component_491,
  '../components/v4/ui/ConfirmDialog/Dialog.js': Component_492,
  '../components/v4/ui/ConfirmDialog/index.js': Component_493,
  '../components/v4/ui/CustomRadioButton/index.js': Component_494,
  '../components/v4/ui/CustomRadioButton/styles.js': Component_495,
  '../components/v4/ui/DeleteDialog/index.js': Component_496,
  '../components/v4/ui/Dialog/index.js': Component_497,
  '../components/v4/ui/ExpiredTrial/index.js': Component_498,
  '../components/v4/ui/Fields/CheckBox/index.js': Component_499,
  '../components/v4/ui/Fields/ColorPicker/index.js': Component_500,
  '../components/v4/ui/Fields/ColorPicker/styles.js': Component_501,
  '../components/v4/ui/Fields/ControlledFormField/index.js': Component_502,
  '../components/v4/ui/Fields/ControlledSelect/index.js': Component_503,
  '../components/v4/ui/Fields/DatePicker/index.js': Component_504,
  '../components/v4/ui/Fields/DateTimePicker/index.js': Component_505,
  '../components/v4/ui/Fields/DirectUploadDropzone/FilesTable.js': Component_506,
  '../components/v4/ui/Fields/DirectUploadDropzone/index.js': Component_507,
  '../components/v4/ui/Fields/Dropzone/index.js': Component_508,
  '../components/v4/ui/Fields/Field/Fields.js': Component_509,
  '../components/v4/ui/Fields/Field/index.js': Component_510,
  '../components/v4/ui/Fields/FlagIcon/Index.js': Component_511,
  '../components/v4/ui/Fields/FlagIcon/styles.js': Component_512,
  '../components/v4/ui/Fields/MultipleSelect/index.js': Component_513,
  '../components/v4/ui/Fields/MultipleSelect/styles.js': Component_514,
  '../components/v4/ui/Fields/PillTextField/index.js': Component_515,
  '../components/v4/ui/Fields/PillTextField/styles.js': Component_516,
  '../components/v4/ui/Fields/SearchSelect/index.js': Component_517,
  '../components/v4/ui/Fields/SearchSelect/styles.js': Component_518,
  '../components/v4/ui/Fields/Select/index.js': Component_519,
  '../components/v4/ui/Fields/SelectWithVisitButton/index.js': Component_520,
  '../components/v4/ui/Fields/SwitchField/index.js': Component_521,
  '../components/v4/ui/Fields/Telephone/index.js': Component_522,
  '../components/v4/ui/Fields/TextField/index.js': Component_523,
  '../components/v4/ui/Fields/TextFieldWithMask/index.js': Component_524,
  '../components/v4/ui/Fields/TimePicker/index.js': Component_525,
  '../components/v4/ui/Form/index.js': Component_526,
  '../components/v4/ui/Icons/bank_slip.js': Component_527,
  '../components/v4/ui/Icons/Check.js': Component_528,
  '../components/v4/ui/Icons/ConfirmEmail.js': Component_529,
  '../components/v4/ui/Icons/credit_card.js': Component_530,
  '../components/v4/ui/Icons/Elo.js': Component_531,
  '../components/v4/ui/Icons/KmlIcon.js': Component_532,
  '../components/v4/ui/Icons/MasterCard.js': Component_533,
  '../components/v4/ui/Icons/Visa.js': Component_534,
  '../components/v4/ui/Icons/WhatsApp.js': Component_535,
  '../components/v4/ui/LoadingComponent/index.js': Component_536,
  '../components/v4/ui/LoadingComponent/styles.js': Component_537,
  '../components/v4/ui/MarkdownEditor/Index.js': Component_538,
  '../components/v4/ui/MarkdownEditor/styles.js': Component_539,
  '../components/v4/ui/NavBar/index.js': Component_540,
  '../components/v4/ui/NavBar/Logo/index.js': Component_541,
  '../components/v4/ui/NavBar/RightGroupMenu/AdminMenu/index.js': Component_542,
  '../components/v4/ui/NavBar/RightGroupMenu/AdminMenu/styles.js': Component_543,
  '../components/v4/ui/NavBar/RightGroupMenu/Alert/index.js': Component_544,
  '../components/v4/ui/NavBar/RightGroupMenu/Alert/styles.js': Component_545,
  '../components/v4/ui/NavBar/RightGroupMenu/index.js': Component_546,
  '../components/v4/ui/NavBar/RightGroupMenu/Notifications/dialogs.js': Component_547,
  '../components/v4/ui/NavBar/RightGroupMenu/Notifications/index.js': Component_548,
  '../components/v4/ui/NavBar/RightGroupMenu/Notifications/NotificationCard.js': Component_549,
  '../components/v4/ui/NavBar/RightGroupMenu/Notifications/styles.js': Component_550,
  '../components/v4/ui/NavBar/RightGroupMenu/OrganizationsMenu/index.js': Component_551,
  '../components/v4/ui/NavBar/RightGroupMenu/OrganizationsMenu/OrganizationsList/index.js': Component_552,
  '../components/v4/ui/NavBar/RightGroupMenu/OrganizationsMenu/SelectedOrganization/index.js': Component_553,
  '../components/v4/ui/NavBar/RightGroupMenu/OrganizationsMenu/styles.js': Component_554,
  '../components/v4/ui/NavBar/RightGroupMenu/ProductsMenu/index.js': Component_555,
  '../components/v4/ui/NavBar/RightGroupMenu/ProductsMenu/ProductsList.js': Component_556,
  '../components/v4/ui/NavBar/RightGroupMenu/ProductsMenu/styles.js': Component_557,
  '../components/v4/ui/NavBar/RightGroupMenu/styles.js': Component_558,
  '../components/v4/ui/NavBar/RightGroupMenu/SupportMenu/index.js': Component_559,
  '../components/v4/ui/NavBar/RightGroupMenu/SupportMenu/styles.js': Component_560,
  '../components/v4/ui/NavBar/styles.js': Component_561,
  '../components/v4/ui/NotificationsDialogs/advancePhenological.js': Component_562,
  '../components/v4/ui/NotificationsDialogs/depthDelayed.js': Component_563,
  '../components/v4/ui/NotificationsDialogs/RegisterCrop.js': Component_564,
  '../components/v4/ui/SideBar/index.js': Component_565,
  '../components/v4/ui/SideBar/styles.js': Component_566,
  '../components/v4/ui/SimpleFields/Telephone/index.js': Component_567,
  '../components/v4/ui/SimpleFields/TextField/index.js': Component_568,
  '../components/v4/ui/SimpleFields/TextFieldWithIcon/index.js': Component_569,
  '../components/v4/ui/SimpleSelect/index.js': Component_570,
  '../components/v4/ui/SimpleSelect/styles.js': Component_571,
  '../components/v4/ui/Stepper/index.js': Component_572,
  '../components/v4/ui/Stepper/styles.js': Component_573,
  '../components/v4/ui/Store/Cart/empty.js': Component_574,
  '../components/v4/ui/Store/Cart/index.js': Component_575,
  '../components/v4/ui/Store/Cart/list.js': Component_576,
  '../components/v4/ui/Store/Cart/styles.js': Component_577,
  '../components/v4/ui/Table/index.js': Component_578,
  '../components/v4/ui/UserUnconfirmedWarning/index.js': Component_579,
  '../components/v4/ui/UserUnconfirmedWarning/styles.js': Component_580,
  '../components/v4/ui/WindDirection/index.js': Component_581,
  '../components/v4/user_privacy_policies/Index.js': Component_582,
  '../components/v4/user_terms/Index.js': Component_583,
  '../components/v4/weather_forecasts/charts/AccumulatedRain/AccumulatedRainChart.js': Component_584,
  '../components/v4/weather_forecasts/charts/AccumulatedRain/Legend.js': Component_585,
  '../components/v4/weather_forecasts/charts/AccumulatedRain/Tooltip.js': Component_586,
  '../components/v4/weather_forecasts/charts/Charts.js': Component_587,
  '../components/v4/weather_forecasts/charts/Default/DefaultChart.js': Component_588,
  '../components/v4/weather_forecasts/charts/ToolTip.js': Component_589,
  '../components/v4/weather_forecasts/charts/WindVelocity/Dot.js': Component_590,
  '../components/v4/weather_forecasts/charts/WindVelocity/Tooltip.js': Component_591,
  '../components/v4/weather_forecasts/charts/WindVelocity/WindVelocityChart.js': Component_592,
  '../components/v4/weather_forecasts/Dashboard.js': Component_593,
  '../components/v4/weather_forecasts/DashboardCharts.js': Component_594,
  '../components/v4/weather_forecasts/DashboardTable.js': Component_595,
  '../components/v4/weather_forecasts/ForecastWrapper.js': Component_596,
  '../components/v4/weather_forecasts/Header/index.js': Component_597,
  '../components/v4/weather_forecasts/Index.js': Component_598,
  '../components/v4/weather_forecasts/PreviewSetting/index.js': Component_599,
  '../components/v4/weather_forecasts/PreviewSetting/PreviewMode.js': Component_600,
  '../components/v4/weather_forecasts/PreviewSetting/Switch.js': Component_601,
  '../components/v4/weather_forecasts/styles.js': Component_602,
  '../components/v4/weather_forecasts/Table/index.js': Component_603,
  '../components/v4/widgets/Card/BatteryStatus.js': Component_604,
  '../components/v4/widgets/Card/Card.js': Component_605,
  '../components/v4/widgets/Card/CardWithDepth.js': Component_606,
  '../components/v4/widgets/Card/CardWithoutDepth.js': Component_607,
  '../components/v4/widgets/Card/DateAndTime.js': Component_608,
  '../components/v4/widgets/Card/Offline.js': Component_609,
  '../components/v4/widgets/Card/TelemetryButton.js': Component_610,
  '../components/v4/widgets/Index.js': Component_611,
  '../components/v4/widgets/NoEquipments.js': Component_612
};

/**
 * Criar contexto compatível com react_ujs
 *
 * react_ujs espera um objeto com:
 * - keys(): retorna array de chaves
 * - resolve(key): resolve uma chave
 * - (key): função de lookup que retorna o módulo
 */
function createComponentContext(componentsMap) {
  const registry = {};

  // Normalizar caminhos para formato que react_ujs espera
  Object.entries(componentsMap).forEach(([path, module]) => {
    // Converter "../components/v4/accounts/Edit.js" para "./accounts/Edit"
    const normalizedKey = path
      .replace(/^\.\.\/components\/v4\//, './')
      .replace(/\.(js|jsx)$/, '');

    // Extrair default export ou usar o módulo completo
    registry[normalizedKey] = module.default || module;
  });

  function lookup(key) {
    // react_ujs pode passar "./ComponentName" ou "ComponentName"
    const normalizedKey = key.startsWith('./') ? key : `./${key}`;
    const component = registry[normalizedKey];

    if (!component) {
      // Tentar sem extensão se não encontrou
      const altKey = normalizedKey.replace(/\.(js|jsx)$/, '');
      return registry[altKey];
    }

    return component;
  }

  // Adicionar métodos esperados pelo react_ujs
  lookup.keys = () => Object.keys(registry);
  lookup.resolve = (key) => key;
  lookup.id = 'components/v4';

  return lookup;
}

// Criar contexto e integrar com react_ujs
const componentRequireContext = createComponentContext(components);
import ReactRailsUJS from "react_ujs";
ReactRailsUJS.useContext(componentRequireContext);

// Garantir que os componentes React sejam processados quando o Turbolinks carregar uma nova página
if (typeof window !== 'undefined') {
  // Função para processar componentes React
  const processReactComponents = () => {
    // Pequeno delay para garantir que o DOM esteja completamente atualizado
    setTimeout(() => {
      if (ReactRailsUJS) {
        if (typeof ReactRailsUJS.handleMount === 'function') {
          ReactRailsUJS.handleMount();
        } else if (typeof ReactRailsUJS.mountComponents === 'function') {
          ReactRailsUJS.mountComponents();
        }
      }
    }, 0);
  };

  // Processar componentes quando o Turbolinks carregar uma nova página
  if (window.Turbolinks) {
    document.addEventListener('turbolinks:load', processReactComponents);

    // Limpar componentes antes do cache para evitar memory leaks
    document.addEventListener('turbolinks:before-cache', () => {
      if (ReactRailsUJS) {
        if (typeof ReactRailsUJS.handleUnmount === 'function') {
          ReactRailsUJS.handleUnmount();
        } else if (typeof ReactRailsUJS.unmountComponents === 'function') {
          ReactRailsUJS.unmountComponents();
        }
      }
    });
  }

  // Processar componentes no carregamento inicial da página
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processReactComponents);
  } else {
    processReactComponents();
  }
}

// As traduções são carregadas automaticamente pelo i18n-init.js
// que importa o arquivo JSON exportado pela gem i18n-js
